exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Toggle-module__wrapper___1PLgY{width:45px;height:22px;background-color:#ececec;transition:.2s;transition-property:background-color;border-radius:22px;position:relative;cursor:pointer}.Toggle-module__wrapper___1PLgY.Toggle-module__inactive___sfx3q{opacity:.5;cursor:auto}.Toggle-module__wrapper___1PLgY.Toggle-module__is-toggled___1CntU{background-color:#2addd0}.Toggle-module__wrapper___1PLgY.Toggle-module__is-toggled___1CntU .Toggle-module__circle___ty-BB{background-color:#fff}.Toggle-module__wrapper___1PLgY .Toggle-module__circle___ty-BB{border-radius:100%;width:18px;height:18px;background-color:#b4bac3;transition:.2s;transition-property:background-color;position:absolute;top:2px;left:2px}", ""]);

// exports
exports.locals = {
	"wrapper": "Toggle-module__wrapper___1PLgY",
	"inactive": "Toggle-module__inactive___sfx3q",
	"is-toggled": "Toggle-module__is-toggled___1CntU",
	"circle": "Toggle-module__circle___ty-BB"
};